import axios from 'apiclient';

const getUserdata = (load) => axios.post('/api/mailerPref/getUserPreferences', { mandant: process.env.CLIENTNAME, ...load }).then((res) => res);
export const setUserdata = (load) => axios.post('/api/mailerPref/setUserPreferences', { mandant: process.env.CLIENTNAME, ...load }).then((res) => res);

export default getUserdata;
